import { useMemo } from 'react'
import PropTypes from 'prop-types'

const NavigationSideBarItem = function (
  {
    title,
    route,
    children,
    boldItem,
    onNavigate,
    showNewBadge = false,
    icon = null,
  }
) {
  const activeChild = useMemo(() => {
    if (!children) {
      return null
    }
    if (!Array.isArray(children)) {
      return children.props?.route === window.location.pathname ? children : null
    }
    return children && children.find((child) => {
      if (!child) {
        return null
      }
      if (child.props?.route === window.location.pathname) {
        return child
      }
      return null
    })
  }, [children])

  if (boldItem) {
    // render just the header but actually link to a route
    const isActive = window.location.pathname === route
    return <div className={`nav-sidebar-item-group ${isActive ? 'nav-sidebar-item-group-active' : ''}`}>
      <div
        className="nav-sidebar-item nav-sidebar-item-title"
        onClick={() => onNavigate(route)}
      >
        {icon && <span className="nav-sidebar-item-icon">{icon}</span>}
        {title}
      </div>
    </div>
  }
  const firstValidChild = Array.isArray(children) ? children.find((e) => e !== false)
    : children
  if (firstValidChild) {
    // render item with children
    let className = 'nav-sidebar-item-group'
    if (activeChild) {
      className += ' nav-sidebar-item-group-active'
    }
    return <div className={className}>
      <div
        className="nav-sidebar-item nav-sidebar-item-title"
        onClick={() => {
          if (!activeChild) {
            onNavigate(firstValidChild.props.route)
          }
        }}
      >
        {icon && <span className="nav-sidebar-item-icon">{icon}</span>}
        {title}
      </div>
      <div className="nav-sidebar-item-children">
        {children}
      </div>
    </div>
  }

  if (!route) {
    // no valid children and no route, we dont want to render just the header
    return null
  }

  // render the actual link
  let className = 'nav-sidebar-item nav-sidebar-item-link'
  let isActive = false
  if (window.location.pathname === route) {
    className += ' nav-sidebar-item-link-active'
    isActive = true
  }
  return <div className={className} onClick={() => !isActive && onNavigate(route)}>
    {title}
    {showNewBadge && <span className="nav-sidebar-item-link-new-badge">New</span>}
  </div>
}

NavigationSideBarItem.propTypes = {
  title: PropTypes.string.isRequired,
  route: PropTypes.string,
  boldItem: PropTypes.bool,
  onNavigate: PropTypes.func,
  showNewBadge: PropTypes.bool,
  icon: PropTypes.node,
}

export default NavigationSideBarItem
